import React from 'react'
import { IconsProps } from 'msp-integrations'

const ArrowLeftIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      viewBox='0 0 141.73 141.73'
    >
      <path d="m90.26 112.3 2.1-2.11L53.61 71.5l38.75-38.69-2.1-2.11-40.88 40.8z" />
    </svg>
  )
}

export default ArrowLeftIcon
